/**
 * Filtres rapides secondaires du Parc.
 *
 * Libellés génériques à dessein (« Propriété tierce », pas « Machines AIS ») :
 * le produit est livré vierge, aucun nom de tiers n'est codé en dur dans un
 * composant partagé. Sur la fiche d'une machine, le nom réel du propriétaire
 * (`ownerName`) s'affiche tel quel — lui, c'est de la donnée, pas du code.
 */
export type ChipParc = 'ais' | 'esp' | 'incomplet';

interface DefinitionChip {
  readonly cle: ChipParc;
  readonly libelle: string;
  readonly count: number;
}

export function ChipsSecondaires({
  thirdPartyOwnedCount,
  espCount,
  incompleteCount,
  valeur,
  onChange,
}: {
  thirdPartyOwnedCount: number;
  espCount: number;
  incompleteCount: number;
  valeur: ChipParc | null;
  onChange: (chip: ChipParc | null) => void;
}) {
  const chips: DefinitionChip[] = [
    { cle: 'ais', libelle: 'Propriété tierce', count: thirdPartyOwnedCount },
    { cle: 'esp', libelle: 'Soumis ESP', count: espCount },
    { cle: 'incomplet', libelle: 'Fiche incomplète', count: incompleteCount },
  ];

  return (
    <div className="chips-secondaires">
      <button
        type="button"
        className={`chip${valeur === null ? ' actif' : ''}`}
        onClick={() => onChange(null)}
      >
        Tout
      </button>
      {chips.map((c) => (
        <button
          key={c.cle}
          type="button"
          className={`chip${valeur === c.cle ? ' actif' : ''}`}
          disabled={c.count === 0}
          onClick={() => onChange(valeur === c.cle ? null : c.cle)}
        >
          {c.libelle} <span className="aide">{c.count}</span>
        </button>
      ))}
    </div>
  );
}
